export const SkillStatusTypes = {
	SOLO: 'solo',
	DISTANT_SUPERVISION: 'distant-supervision',
	DIRECT_SUPERVISION: 'direct-supervision',
	NO_EXPERIENCE: 'no-experience',
	MANDATORY: 'mandatory',
	RECOMMENDED: 'recommended',
	NOT_REQUIRED: 'not-required',
};

export const SkillsFilterProperties = {
	JOB_TITLE_ID: 'jobTitleId',
	DEPARTMENT_ID: 'departmentId',
};

export const SkillsUserRoles = {
	PRACTITIONER: 'practitioner',
	NURSE: 'nurse',
	ASSISTANT: 'assistant',
};

export const SkillsMapStatus = {
	PENDING: 'pending',
	APPROVED: 'approved',
};

export const SkillsType = {
	JOB: 'job',
	USER: 'user',
};

export const ShiftSkillStatuses = {
	LEVEL_CHANGE: 'levelChange',
	ACQUIRED_BY_STAFF: 'acquiredByStaff',
};
